import Papa from 'papaparse';
// Component
const ModalMultiplePrice = () => import(/* webpackPrefetch: true, webpackChunkName: "modal-multiple-price"*/ '@/app/views/main-view/_shared/_components/modals/modal-multiple-price/modal-multiple-price.vue');

// Mixins
import { tableMixins } from '@/app/mixins/utils/table-mixins.js';
import { productMixins } from '@/app/mixins/modules/product-mixins.js';
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins.js';

// Services
import productService from '@/app/services/main/product/product-service.js';


export default {
	name: 'BatchProductsContainer',
	components: {
		ModalMultiplePrice
	},
	mixins: [
		tableMixins,
		productMixins,
		toastMessageMixins
	],
	data() {
		return {
			isAPILoading: false,
			modalContent: {},
			// table
			theads: [
				{ name: 'SKU'},
				{ name: 'Name'},
				{ name: 'Description'},
				{ name: 'Qty'},
				{ name: 'Cost'},
				{ name: 'Cost Inc Tax'},
				{ name: 'Retail'},
				{ name: 'Type'},
				{ name: 'Size'},
				{ name: 'Age'},
				{ name: 'Brand'},
				{ name: 'Supplier'},
			],
			// sorting
			desc: true,
			file: '',
			content: [],
			parsed: false,
		}
	},
	props: {
		isDashboard: {
			type: Boolean,
			default: false
		}
	},
	
	methods: {
		rowStyle(product) {
			const {sku, name, age, size, type} = product;
			
			if ([sku, name, age, size, type].some(item => item === "")) {
				return "background-color: #ff00004d;";
			}
			
			
		},
		onPickFile() {
			this.$refs.fileInput.click();
		},
		onFilePicked(event) {
			this.file = event.target.files[0];
			this.parseFile();
		},
		parseFile(){
			Papa.parse( this.file, {
				header: true,
				skipEmptyLines: true,
				complete: function( results ){
					this.content = results;
					this.parsed = true;
					this.tableContent = {
						tableData: results.data,
						paginationData: {
							limit: 0,
							page: 0,
							pageCount: 0,
							totalCount: 0
						}
					};
				}.bind(this)
			} );
		},
		onPickImages() {
			this.$refs.uploader.click();
		},

		saveProducts(){
			productService.postMultipleProducts(this.content.data)
				.then(res => {
					if(res.status === 200){
						const {
							newProduct,
							updateProduct,
							failedProduct
						} =res.data;
						
						this.$swal({
							title: 'Done Uploading Products',
							html: `
								<table style="width:100%">
									<tr>
										<th style="border: 1px solid #ddd; padding: 8px; background-color: #28a745; color: white;">New Product</th>
										<th style="border: 1px solid #ddd; padding: 8px; background-color: #17a2b8; color: white;">Updated Product</th>
										<th style="border: 1px solid #ddd; padding: 8px; background-color: #ff00004d; color: white;">Failed Product</th>
									</tr>
									<tr>
										<td style="padding: 8px; font-size:15pt; font-weight:bold">${newProduct}</td>
										<td style="padding: 8px; font-size:15pt; font-weight:bold">${updateProduct}</td>
										<td style="padding: 8px; font-size:15pt; font-weight:bold">${failedProduct}</td>
									</tr>
								</table>
								`,
							showCancelButton: false,
							cancelButtonText: 'Cancel',
							reverseButtons: true,
							showCloseButton: true
						});
						this.content = [];
						this.tableContent = {
							tableData: "",
							paginationData: {
								limit: 0,
								page: 0,
								pageCount: 0,
								totalCount: 0
							}
						};
					}
					
					
				});
		},
		downloadTemplate() {
            
            this.$swal({
                title: `Download Product CSV Template`,
                html: `
				<p>Guideline to fill up the CSV form to upload the product</p>
				<table style="width:100%">
					<tr>
						<th style="border: 1px solid #ddd; padding: 8px; text-align: left; background-color: #04AA6D; color: white;">Column Name</th>
						<th style="border: 1px solid #ddd; padding: 8px; text-align: left; background-color: #04AA6D; color: white;">Description</th>
						<th style="border: 1px solid #ddd; padding: 8px; text-align: left; background-color: #04AA6D; color: white;">Remarks</th>
					</tr>
					<tr>
						<td style="text-align: left;">sku</td>
						<td style="text-align: left;">SKU number</td>
						<td style="color:red">Required</td>
					</tr>
					<tr>
						<td style="text-align: left;">name</td>
						<td style="text-align: left;">Product Name</td>
						<td style="color:red">Required</td>
					</tr>
					<tr>
						<td style="text-align: left;">description</td>
						<td style="text-align: left;">Description of Product</td>
						<td>Optional</td>
					</tr>
					<tr>
						<td style="text-align: left;">qty</td>
						<td style="text-align: left;">Stock Quantity</td>
						<td>Optional</td>
					</tr>
					<tr>
						<td style="text-align: left;">cost</td>
						<td style="text-align: left;">Product Cost</td>
						<td>Optional</td>
					</tr>
					<tr>
						<td style="text-align: left;">cost_inc_tax</td>
						<td style="text-align: left;">Cost include Tax</td>
						<td>Optional</td>
					</tr>
					<tr>
						<td style="text-align: left;">retail</td>
						<td style="text-align: left;">Selling Price</td>
						<td>Optional</td>
					</tr>
					<tr>
						<td style="text-align: left;">type</td>
						<td style="text-align: left;">Type of Product</td>
						<td style="color:red">Required</td>
					</tr>
					<tr>
						<td style="text-align: left;">size</td>
						<td style="text-align: left;">Dog Size</td>
						<td style="color:red">Required</td>
					</tr>
					<tr>
						<td style="text-align: left;">age</td>
						<td style="text-align: left;">Dog Age</td>
						<td style="color:red">Required</td>
					</tr>
					<tr>
						<td style="text-align: left;">brand</td>
						<td style="text-align: left;">Product Brand</td>
						<td>Optional</td>
					</tr>
					<tr>
						<td style="text-align: left;">supplier</td>
						<td style="text-align: left;">Supplier Name</td>
						<td>Optional</td>
					</tr>
				</table>
				<hr>
				<em><strong>**Fill-up all required field to succesfully upload the product</strong></em>
				`,
                confirmButtonText: "Download",
                showCancelButton: true,
                cancelButtonText: "Cancel",
                reverseButtons: false,
				showCloseButton: true
            }).then((result) => {
				if (result.isConfirmed) {
					let csvContent = "sku,name,description,qty,cost,cost_inc_tax,retail,type,size,age,brand,supplier\n";

					let blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

					let link = document.createElement("a");
					if (link.download !== undefined) {
						// Set the download attribute and the file name
						let url = URL.createObjectURL(blob);
						link.setAttribute("href", url);
						link.setAttribute("download", "product_csv_template.csv");

						// Simulate a click on the anchor element to trigger the download
						link.style.visibility = "hidden";
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
					}
				}
                
            });
        },
		
	}
}